/* eslint-disable react-hooks/exhaustive-deps */
import './MembersProfilePage.scss';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from '@reach/router';
import { Carousel } from 'antd';
import parse from 'html-react-parser';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { queryClient } from '../../../../../../App';
import HEART from '../../../../../../assets/images/heart.png';
import HEARTFILL from '../../../../../../assets/images/heart_fill.png';
import ANALSEX from '../../../../../../assets/images/InterestsBadges/anal_sex.png';
import EROTICMASSAGE from '../../../../../../assets/images/InterestsBadges/erotic_massage.png';
import EXCHANGEPICTURE from '../../../../../../assets/images/InterestsBadges/exchange_pictures.png';
import KISSING from '../../../../../../assets/images/InterestsBadges/kissing.svg';
import LINGERIE from '../../../../../../assets/images/InterestsBadges/lingerie.svg';
import ORALSEX from '../../../../../../assets/images/InterestsBadges/oral_sex.png';
import PUBLICSEX from '../../../../../../assets/images/InterestsBadges/public_sex.png';
import SAFESEX from '../../../../../../assets/images/InterestsBadges/safe_sex.png';
import THREESOME from '../../../../../../assets/images/InterestsBadges/threesome.png';
import ProfilePlaceholder from '../../../../../../assets/images/Temp/ProfileImage.jpg';
import Button from '../../../../../../components/Button/Button';
import ImageComponent from '../../../../../../components/ImageComponent/ImageComponent';
import ImageComponentPreview from '../../../../../../components/ImageComponentPreview/ImageComponentPreview';
import ImageN from '../../../../../../components/ImageN/ImageN';
import ImageNPreview from '../../../../../../components/ImageNPreview/ImageNPreview';
import LoaderComponent from '../../../../../../components/LoaderCompoment/LoaderComponent';
import SuccessMessage from '../../../../../../components/SuccessMessage/SuccessMessage';
import { key as favouritesKey } from '../../../../../../core/APIHooks/useGetFavourites';
import { useGetUserData } from '../../../../../../core/APIHooks/userData/useGetUserData';
import { setTrigger } from '../../../../../../redux/actions/subscriptionTriggers.js';
import { authMe } from '../../../../../../services/auth-service/auth.service';
import {
  addToFavorite,
  getProfileById,
  getProfileImages,
  getProfilePictures,
} from '../../../../../../services/profile-service/profile.service';
import { getToken } from '../../../../../../services/token-service/token.service';
import { Triggers } from '../../../../../../V2/model/Triggers';
import { MEMBERS_ROUTES } from '../../members_routes';
// import { getUserData } from '../../../../../../services/user-service/user.service';
import { showMessagesPage } from '../../navigation.service';
import { GiftModal } from './components/GiftModal';

const MembersProfilePage = (props) => {
  const { userId, sideBar } = props;
  // const userData = getUserData();
  const { data: userData } = useGetUserData();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [favourites, setFavourites] = useState(false);
  const [showSuccesMessage, setShowSuccesMessage] = useState(false);
  const [showRemoveMessage, setShowRemoveMessage] = useState(false);
  const [addedFavourite, setAddedFavourite] = useState(false);
  const [windowWidth, getWindowWidth] = useState(window.innerWidth);
  const [isPremium, setIsPremium] = useState(userData?.premium);
  const [pictures] = useState([]);
  const [token, setToken] = useState();
  const [galleryImagesURL, setGalleryImagesURL] = useState([]);
  const dispatch = useDispatch();
  let arrayGalleryImages = [];
  const getUrl = window.location.pathname;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const currentUserId = getUrl.split('/').pop();
  const navigate = useNavigate();
  const [giftModalOpen, setGiftModalOpen] = useState(false);

  const interests = {
    kissing: {
      title: 'Kissing',
      image: KISSING,
    },
    'exchanging pictures': {
      title: 'Exchanging Pictures',
      image: EXCHANGEPICTURE,
    },
    'safe sex': {
      title: 'Safe Sex',
      image: SAFESEX,
    },
    'erotic massage': {
      title: 'Erotic Massage',
      image: EROTICMASSAGE,
    },
    lingerie: {
      title: 'Lingerie',
      image: LINGERIE,
    },
    'oral sex': {
      title: 'Oral Sex',
      image: ORALSEX,
    },
    threesome: {
      title: 'Threesome',
      image: THREESOME,
    },
    'anal sex': {
      title: 'Anal Sex',
      image: ANALSEX,
    },
    'public sex': {
      title: 'Public Sex',
      image: PUBLICSEX,
    },
  };

  useEffect(() => {
    if (urlParams.has('paymentstatus')) {
      authMe().then((res) => {
        res.data.data.premium !== undefined && setIsPremium(res.data.data.premium);
        localStorage.setItem('userData', JSON.stringify(res.data));
        // if (!isPremium) {
        //   membersPricing();
        // }
      });
    }
  }, [urlParams.has('paymentstatus'), isPremium]);

  useEffect(() => {
    userData?.premium !== undefined && setIsPremium(userData?.premium);
  }, [userData]);

  useEffect(() => {
    const authMeFailed = (err) => {
      console.log(err);
    };

    const authMeSuccess = (res) => {
      let favouritesArray = res.data.data?.favorite_profiles;
      setFavourites(favouritesArray.findIndex((x) => x.id === data?.id));
      res.data.data?.premium !== undefined && setIsPremium(res.data.data?.premium);
    };

    authMe(getToken).then(authMeSuccess).catch(authMeFailed);
  }, [data]);

  const getProfileFailure = (error) => {
    setLoading(false);
    console.log(error, 'failed');
  };

  const getProfileSuccess = (response) => {
    const { data } = response.data;
    setData(data);
    setLoading(false);
  };

  useEffect(() => {
    const handleResize = () => {
      getWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);

  const getNewProfilePictures = useCallback(async () => {
    try {
      const response = await getProfileImages(userId);
      const pictures = response.data.data.gallery_images;
      setGalleryImagesURL(pictures);
      const promises = pictures.map((mImg, index) => {
        getProfilePictures(mImg.thumbnail_url, token)
          .then((response) => {
            let blob = new Blob([response.data], {
              type: response.headers['content-type'],
            });
            return blob;
          })
          .then((myBlob) => {
            var objectURL = URL.createObjectURL(myBlob);
            arrayGalleryImages.push({ url: objectURL });
            return objectURL;
          });
      });

      // const results = await Promise.all({ url: promises });
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    getProfileById(userId).then(getProfileSuccess).catch(getProfileFailure);

    setToken(getToken);
    getNewProfilePictures(pictures);
  }, [userId, isPremium]);

  const renderLoader = () => {
    return (
      <div className="Loading">
        <div className="LoadingText">Loading Profile...</div>
        <LoaderComponent />
      </div>
    );
  };

  const handlePricing = () => {
    const currentUrl = window.location.host;
    const redirectionUrl = 'members-area/member-profile/';
    localStorage.setItem('userId', currentUserId);

    const finalRedirectUrl = currentUrl + redirectionUrl + localStorage.getItem('userId');

    dispatch(
      setTrigger({
        profile_id: localStorage.getItem('userId'),
        subscription_trigger: 'profile',
        redirect_url: finalRedirectUrl,
      }),
    );
    navigate(`${MEMBERS_ROUTES.MEMBERSAREA}${MEMBERS_ROUTES.MEMBERSPRICING}`, {
      state: {
        trigger: Triggers.PROFILE,
        id: data?.id,
      },
    });
  };

  const sendMessagePage = () => {
    const currentUrl = window.location.host;
    const redirectionUrl = '/members-area/member-profile/';
    localStorage.setItem('userId', currentUserId);
    localStorage.setItem(
      'redirect_url',
      currentUrl + redirectionUrl + localStorage.getItem('userId'),
    );
    showMessagesPage(userId);
  };

  const addFavouriteFailed = (err) => {
    console.log(err);
    setAddedFavourite(false);
    setShowSuccesMessage(false);
  };

  const addFavouriteSuccess = (res) => {
    console.log(res);
    setAddedFavourite(true);
    setShowSuccesMessage(true);
  };

  const addToFavourite = () => {
    setAddedFavourite(false);
    setShowSuccesMessage(false);
    addToFavorite(userId, getToken())
      .then(addFavouriteSuccess)
      .then(() => queryClient.invalidateQueries(favouritesKey))
      .catch(addFavouriteFailed);
  };

  const alredyFavourite = (e) => {
    e.preventDefault();
  };

  const renderFavourite = () => {
    return (
      <div
        className="FavouriteIconContainer"
        onClick={favourites === -1 || favourites === false ? addToFavourite : alredyFavourite}
      >
        <ImageComponent
          className="FavouriteIcon"
          url={favourites > -1 || addedFavourite ? HEARTFILL : HEART}
        />
      </div>
    );
  };

  const renderUnlockButton = () => {
    return (
      <div className="UnlockButton" onClick={handlePricing}>
        Unlock the Photo
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: 'black',
          fontSize: '15px',
          lineHeight: '1.5715',
        }}
        onClick={onClick}
      >
        <LeftOutlined style={{ color: 'white', fontSize: 25 }} />
      </div>
    );
  };

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: 'black',
          fontSize: '15px',
          lineHeight: '1.5715',
        }}
        onClick={onClick}
      >
        <RightOutlined style={{ color: 'white', fontSize: 25 }} />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const renderInterests = () => {
    return (
      <div className="InterestsContainer">
        {typeof data?.interests === 'object' ? (
          data?.interests?.map((item, index) => {
            return (
              <div className="InterestHolder" key={index}>
                <ImageComponent url={interests[item]?.image} />
                <span>{item}</span>
              </div>
            );
          })
        ) : (
          <div className="InterestHolder">
            <ImageComponent url={interests[data?.interests]?.image} />
            <span>{data?.interests}</span>
          </div>
        )}
      </div>
    );
  };

  const stringToHTML = () => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data?.description, 'text/html');
    return <div className="DescriptionContainer">{parse(doc.body.innerHTML)}</div>;
  };

  const renderButton = !isPremium ? renderUnlockButton() : '';
  const renderUserProfile = () => {
    return (
      <div className={sideBar ? 'UserProfileContainer SidebarActive' : 'UserProfileContainer'}>
        <div className="AboutMeContainer">
          <div className="Title">About Me</div>
          {stringToHTML()}
          <div className="Title">My Interests</div>
          {data && renderInterests()}
        </div>
        <div className={sideBar ? 'SidebarOpened ProfileInfo' : 'ProfileInfo'}>
          <div className="ProfilePhotoUsername">
            <div
              className={sideBar ? 'ProfilePhotoContainer ActiveSidebar' : 'ProfilePhotoContainer'}
            >
              <Carousel arrows {...settings}>
                <div className="ImageContainer">
                  {data?.avatar_image?.thumbnail_url ? (
                    <ImageNPreview
                      nameFullSize={data?.avatar_image?.url}
                      name={data?.avatar_image?.thumbnail_url}
                    />
                  ) : (
                    <ImageComponentPreview url={ProfilePlaceholder} />
                  )}
                </div>
                {galleryImagesURL
                  ? galleryImagesURL.map((mImg, index) => {
                      if (mImg.type === 'gallery') {
                        return (
                          <div className="ImageContainer" key={index}>
                            {renderButton}
                            {isPremium ? (
                              <ImageNPreview name={mImg.thumbnail_url} nameFullSize={mImg.url} />
                            ) : (
                              <ImageN name={mImg.thumbnail_url} />
                            )}
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })
                  : null}
              </Carousel>
              {!isPremium ? renderUnlockButton(data?.id) : ''}
              {renderFavourite()}
            </div>
            <div className="UsernameContainer">
              {data?.username}{' '}
              <span
                className={data?.online_status ? 'OnlineStatus Online' : 'OnlineStatus Offline'}
              />
            </div>
            <div className="SendMessageButtonContainer">
              <Button onClick={sendMessagePage} text="Send a message" />
            </div>
            <div className="SendMessageButtonContainer">
              <Button onClick={() => setGiftModalOpen(true)} text="Send a gift" />
            </div>
          </div>
        </div>
        <div className="profile-facts facts-only">
          <div
            className={sideBar ? 'ProfileFactsContainer SidebarOpened' : 'ProfileFactsContainer'}
          >
            <div className="ProfileFactsTitle">Profile Facts</div>
            <div className="FactContainer">
              Age: {new Date().getFullYear() - data?.birthday.slice(0, 4)}{' '}
            </div>
            <div className="FactContainer">
              City:{' '}
              <span className="LinkToPage" onClick={sendMessagePage}>
                Ask for my city
              </span>
            </div>
            <div className="FactContainer">Height: {data?.height}</div>
            <div className="FactContainer">Body type: {data?.body_build}</div>
            <div className="FactContainer">
              Status: {data?.civil_status === 'taken' ? 'In a Relationship' : data?.civil_status}
            </div>
            <div className="FactContainer">Hair Color: {data?.hair_color}</div>
            <div className="FactContainer">Eye Color: {data?.eye_color}</div>
            <div className="AskQuestion">
              Want to know more? <br className="break" />{' '}
              <span onClick={sendMessagePage}>Ask me a question!</span>
            </div>
          </div>
        </div>
        <GiftModal
          redirect={'/members-area/messagesnew/'}
          open={giftModalOpen}
          onCancel={() => setGiftModalOpen(false)}
          profileId={data?.id}
          profileUsername={data?.username}
        />
        <SuccessMessage
          showMessage={showSuccesMessage}
          setShowMessage={setShowSuccesMessage}
          message="Successfully Added To My Favourites"
        />
        <SuccessMessage
          showMessage={showRemoveMessage}
          setShowMessage={setShowRemoveMessage}
          message="Removed from Favourites"
        />
      </div>
    );
  };

  return <div className="MembersProfilePage">{loading ? renderLoader() : renderUserProfile()}</div>;
};

export default MembersProfilePage;
